'use client';

import Link from 'next/link';
import { 
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-gray-50 p-4 md:p-8">
      <Card className="max-w-4xl mx-auto">
        <CardHeader>
          <CardTitle className="text-3xl text-center">Terms of Service</CardTitle>
        </CardHeader>
        <CardContent className="prose prose-slate max-w-none">
          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing and using Solynta Academy, you agree to be bound by these Terms of Service.
            If you do not agree to these terms, please do not use our services.
          </p>

          <h2>2. User Accounts</h2>
          <p>
            You are responsible for maintaining the confidentiality of your account credentials
            and for all activities that occur under your account.
          </p>

          <h2>3. Educational Content</h2>
          <p>
            All educational content provided through Solynta Academy is for learning purposes only.
            We strive to ensure accuracy but make no guarantees about the completeness or reliability
            of the content.
          </p>

          <h2>4. User Conduct</h2>
          <p>
            Users must not engage in any activity that disrupts or interferes with our services,
            including attempting to gain unauthorized access to any part of the platform.
          </p>

          <h2>5. Intellectual Property</h2>
          <p>
            All content and materials available through Solynta Academy are protected by
            intellectual property rights and may not be used without our permission.
          </p>

          <h2>6. Changes to Terms</h2>
          <p>
            We reserve the right to modify these terms at any time. Continued use of the platform
            after changes constitutes acceptance of the modified terms.
          </p>

          <h2>7. Weekly Cohort Programmes</h2>
          <p>
            Paid weekly cohort programmes (Prompt to Production and any future weekly programmes)
            are subject to these additional terms alongside our general Terms of Service:
          </p>
          <ol>
            <li>
              Cohort fees are one-time, per enrolment. See current pricing at{' '}
              <Link href="/ai-skills/build-software" className="text-primary hover:underline">
                solynta.academy/ai-skills/build-software
              </Link>{' '}
              (adults) or{' '}
              <Link href="/ng/home/weekly-programs" className="text-primary hover:underline">
                solynta.academy/ng/home/weekly-programs
              </Link>{' '}
              (kids).
            </li>
            <li>
              Full refund is available if requested before your cohort&apos;s Saturday 1 session begins.
              After that point, fees are non-refundable except as required by law.
            </li>
            <li>
              If Solynta cancels a cohort, enrolees receive a full refund or the option to transfer
              to another cohort.
            </li>
            <li>
              Learners must attend the cohort they enrolled into. Transfers between cohorts require
              Solynta&apos;s prior written consent.
            </li>
            <li>
              Certificates are issued to learners who complete all four Saturday sessions and
              submit the required deliverables per the programme curriculum.
            </li>
            <li>
              Featuring of learner work on public pages (e.g. solynta.academy/showcase) requires
              explicit opt-in. Default is private.
            </li>
          </ol>

          <div className="mt-8 text-center">
            <Link href="/login" className="text-primary hover:underline">
              Back to Login
            </Link>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
